<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>签到码</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask_con">
                    <img :src="urls + dataVal.qrcode" alt="" srcset="">
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="downloadText">下载二维码</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "checkinCode",
    props: ['dataVal'],
    data() {
        return {
            urls: this.imgurl,
            qrcode: ''
        };
    },
    mounted() {
    },
    methods: {
        getUrlBase64(imgUrl) {
            return new Promise((resolve) => {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                let img = new Image(); //允许进行跨域
                img.crossOrigin = "Anonymous";
                img.src = imgUrl;
                img.onload = function () {
                    canvas.height = img.height; //图片的高度
                    canvas.width = img.width;//图片的宽度
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    let dataURL = canvas.toDataURL("image/png");
                    canvas = null;
                    resolve(dataURL);
                };
            });
        },
        //点击下载图片按钮的事件
        downloadText(urls, name) {
            let url = this.urls + this.dataVal.qrcode;
            this.getUrlBase64(url).then((base64) => {
                const link = document.createElement("a");
                link.download = this.dataVal.name + '签到码';
                link.href = base64;
                // link.download = this.$route.query.source;
                link.click();
            });
        },

        // async downloadText(urls, name) {
        //     // 创建隐藏的可下载链接
        //     const a = document.createElement('a');
        //     a.style.display = 'none';
        //     a.href = this.urls + this.dataVal.qrcode;
        //     // 保存下来的文件名
        //     a.download = this.dataVal.name + '签到码';
        //     document.body.appendChild(a);
        //     a.click();
        //     // 移除元素
        //     document.body.removeChild(a);
        // },
        async activitySetqrcode() {

        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("checkinCodeCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                form: this.form
            }
            this.$emit("checkinCodeCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {

                }
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 714px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
                cursor: pointer;
            }
        }

        .mask-content-body {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #FFF;
            padding: 75px 20px 20px 33px;

            .mask_con {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    width: 430px;
                    height: 430px;
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 142px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>